import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { AccordionDetails } from '@mui/material';

const Skills = () => {

    const [openAccordion, setOpenAccordion] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setOpenAccordion((prevAccordion) => (prevAccordion + 1) % 3);
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const handleAccordionClick = (index:number) => {
        setOpenAccordion(index);
    };

    return (
        <section className="skils section" id="skills">
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">My Technical level</span>


            <div className="skills__container container grid">
                <div>

                    {/* <!-- ================= Skills 1======================--> */}
                    <Accordion
                        elevation={0}
                        style={{ backgroundColor: 'transparent' }}
                        expanded={openAccordion === 0}
                        onClick={() => handleAccordionClick(0)}
                    >

                        <AccordionSummary
                            expandIcon={<i className="uil uil-angle-down skills__arrow"></i>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div className="skills__header">
                                <i className="uil uil-brackets-curly skills__icon"></i>

                                <div>
                                    <h1 className="skills__titles">Frontend Technos</h1>
                                    <span className="skills__subtitle">More than 2 years</span>
                                </div>

                            </div>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="skills__list grid">

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">HTML</h3>
                                        <span className="skills__number">80%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__html"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">CSS</h3>
                                        <span className="skills__number">70%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__css"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Javascript</h3>
                                        <span className="skills__number">80%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__js"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">React</h3>
                                        <span className="skills__number">70%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__react"></span>
                                    </div>
                                </div>

                            </div>
                        </AccordionDetails>
                    </Accordion>

                    {/* 
                    
                    <!-- ================= Skills 2======================--> 

                    */}
                    <Accordion
                        elevation={0}
                        style={{ backgroundColor: 'transparent' }}
                        expanded={openAccordion === 1}
                        onClick={() => handleAccordionClick(1)}
                    >

                        <AccordionSummary
                            expandIcon={
                                <i className="uil uil-angle-down skills__arrow"></i>
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div className="skills__header">
                                <i className="uil uil-server-network skills__icon"></i>

                                <div>
                                    <h1 className="skills__titles">Backend Technos</h1>
                                    <span className="skills__subtitle">More than 1 years</span>
                                </div>

                            </div>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="skills__list grid">

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">PHP</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__php"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Node JS</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__node"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">SQL</h3>
                                        <span className="skills__number">70%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__sql"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Python</h3>
                                        <span className="skills__number">30%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__python"></span>
                                    </div>
                                </div>

                            </div>
                        </AccordionDetails>
                    </Accordion>

                </div>

                <div>

                    {/* <!-- ================= Skills 3======================--> */}
                    <Accordion
                        elevation={0}
                        style={{ backgroundColor: 'transparent' }}
                        expanded={openAccordion === 2}
                        onClick={() => handleAccordionClick(2)}
                    >

                        <AccordionSummary
                            expandIcon={
                                <i className="uil uil-angle-down skills__arrow"></i>
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div className="skills__header">
                                <i className="uil uil-swatchbook skills__icon"></i>

                                <div>
                                    <h1 className="skills__titles">Designer Tools</h1>
                                    <span className="skills__subtitle">More than 1 years</span>
                                </div>
                            </div>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="skills__list grid">

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Figma</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__figma"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Sketch</h3>
                                        <span className="skills__number">30%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__sketch"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Photoshop</h3>
                                        <span className="skills__number">30%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__photoshop"></span>
                                    </div>
                                </div>

                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Adobe XD</h3>
                                        <span className="skills__number">30%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__adobe"></span>
                                    </div>
                                </div>

                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>

            </div>
        </section >

    )
}

export default Skills